import { createContext } from 'react';
import type { ToastItem, ToastOptions, ToastSeverity } from './types';

export type ToastContextValue = {
  toasts: ToastItem[];
  show(title: string, severity: ToastSeverity, options?: ToastOptions): string;
  dismiss(id: string): void;
};

export const ToastContext = createContext<ToastContextValue | null>(null);
